import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { SubscriptionBannerComponent } from './subscription-banner.component';

@NgModule({
  imports: [CommonModule, MatCardModule, PipeModule, SubscriptionBannerComponent],
  exports: [SubscriptionBannerComponent],
})
export class SubscriptionBannerModule {}
